/**
 * Converts an account or brand name to a SID (string identifier)
 * @function nameToSid
 * @param {string} name
 * @return {string}
 * @example nameToSid('Fake Shakes') => 'fake-shakes'
 * @example nameToSid('Fake$ $Shakes') => 'fake-shakes' -- Removes special characters
 * @example nameToSid('Fake  Shakes') => 'fake-shakes' -- Removes extra spaces/hyphens
 */
const nameToSid = (name) => {
  return name.toLowerCase()
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-') // replace multiple hyphens with a single hyphen
    .replace(/[^a-z0-9-]/gi, '') // remove invalid characters
    .replace(/-+$/, ''); // remove trailing hyphens
};

export default nameToSid;
